export default __webpack_public_path__ + "static/media/Everybyte_logo.ca90aa8b.png";